// extracted by mini-css-extract-plugin
export default {"pricingRows":"style--pricingRows--579b97","container":"style--container--491dc0","attention":"style--attention--a4562f","servicePrices":"style--servicePrices--af318f"};